<template>
    <headboard></headboard>
    <div class="" style="padding-left:5%;padding-right:5%;">

        <div class="row mt-5">
            <div class="col-sm-12">
                <div class="instant">
                    <h2 class="modspec_title">Instant Pricing [beta]</h2>
                    <p>Seamlessly coordinate energy compliance for your residential or commercial construction project.</p>
                    <p style="font-size: smaller;">Please Note: Our scoping tool is in early stage development and as such, we welcome any feedback or suggestions to improve its functionality.</p>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <newQuote ref="buildQuote" @savedQuote="savedQuote($event)" @setQuote="quote = $event"
                    @setMethod="method = $event" :idCliente="idClient" :idUser="idUser" :showSave="0" />
            </div>
            <div class="col-sm-2"></div>

            <div class="col-sm-4">
                <div class="sticky">
                    <sumary :quote="quote" :method="method" @setResume="setResume($event)" @setLeadTime="setLeadTimer($event)" />
                    <div class="row mt-3" v-if="getPrice != 0">
                        <div class="col-sm-3">
                            <loadingbutton :loading="savingQuote" @pressed="saveQuote" :disabled="savingQuote" buttonText="Save" />
                            <button v-if="false" type="button" class="btn btn-primary" style="margin-left:10px;">Download Quote</button>
                            <button v-if="false" type="button" class="btn btn-primary" style="margin-left:10px;">Accept Fee</button>
                        </div>
                        <div class="col-sm-9" v-if="isAdmin">
                                <input class="form-check-input" type="checkbox" name="chkQuoteSendMail"
                                    id="chkQuoteSendMail" value="0" v-model="sendQuoteMail" />
                                <label class="form-check-label modspec_font12" for="chkQuoteSendMail"
                                    >Send email to client </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!-----PERTENECE A SUMMARY, da problemas si se coloca adentro-------------------------------------->
    <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlInfoUrgentLead" id="btnOpenInfoUrgentLead">Open</button>
  <div class="modal fade" id="mdlInfoUrgentLead" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Urgent Lead Time</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <p>If our standard lead time does not fit the project timeline, and the assessment is needed to be completed as a matter of urgency, you can opt to pay a premium and we will start the assessment immediately, ensuring it is completed as soon as is possible. Depending on the project size, it may be possible for us to have results to you same day. This requires us to push back other assessments.</p>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRoute } from "vue-router";
import header from "../components/header.vue"
import sumary from "../components/sumary.vue"
import newQuote from "@/components/quote/new-quote.vue";
import loadingbutton from "@/components/global/loading-button.vue";

export default {
    name: 'scoping-tool',
    data: function () {
        return {
            idClient: 0,
            idUser:'',
            method: {},
            quote:null,
            isSaving:false,
            sendQuoteMail:true
        }
    },
    components: {
        'newQuote': newQuote,
        'headboard': header,
        'sumary': sumary,
        loadingbutton
    },
    mounted() {
        const route = useRoute();
        if(route.params.id){
            let s = route.params.id
            //recibe dos parámetro idUsuario e idCliente
            let r = s.split('|')
            if(r[0] != 'null'){
                this.idUser = r[0];
            }
            this.idClient = parseInt(r[1]);
        }
        
    },
    computed:{
        getPrice(){
            if(this.quote != null){
                return this.quote.Price;
            }
            return 0;
        },
        savingQuote(){
            return this.$refs.buildQuote.isSaving;
        },
        isAdmin(){
            let usrr = this.$vtc.getUsuarioLogueado();
            if(usrr){
                return usrr.isAdmin
            }
            return false
        }
    },
    methods: {
        saveQuote() {
            this.$refs.buildQuote.saveNewQuote(this.sendQuoteMail);
        },
        savedQuote() {
            let rui = this.$vtc.getUsuarioLogueado()

            if(rui.isAdmin){
                window.location.href = this.$vtc.getConfig().getHomeUrl() + "/administration/client/"+this.idClient;
                return true;
            }
            window.location.href = this.$vtc.getConfig().getHomeUrl() + "/user";
        },
        setResume(summary){
            this.$refs.buildQuote.setResume(summary);
        },
        setLeadTimer(isLeadTime){
            this.$refs.buildQuote.setLeadTime(isLeadTime);
        }
    }
}
</script>
<style>
.instant {
    background-color: #232527;
    color: white;
    padding: 2em 10px 2em 10px;
}

.price {
    font-weight: bold;
    font-size: 22px;
}

.sticky {

    position: -webkit-sticky;
    position: sticky;
    top: 0;

}
</style>